import convert from 'color-convert'

import random from 'lodash/random'

export default (hexColor) => {
  const [h, s, l] = convert.hex.hsl(hexColor)

  return '#' + convert.hsl.hex([
    Math.max(0, Math.min(359, h + random(-15, 15))),
    Math.max(0, Math.min(100, s + random(-5, 5))),
    Math.max(0, Math.min(100, l + random(-5, 5)))
  ])
}
